import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_BRAND_VOICE_BY_BUSINESS_UNIT_ID = registerQuery({
  fieldName: 'fetchBrandVoiceByBusinessUnitId',
  args: ['businessUnitId'],
  fetcher: ({
    businessUnitId
  }) => http.get(`branding/v1/brand-voice/by-bu-id/${businessUnitId}`)
});
export const GET_BRAND_KIT_BY_BUSINESS_UNIT_ID = registerQuery({
  fieldName: 'fetchBrandKitByBusinessUnitId',
  args: ['businessUnitId'],
  fetcher({
    businessUnitId
  }) {
    return http.get(`branding/v1/brand-kit/business-unit/${businessUnitId}`);
  }
});